export const getLocalStoreInt = (key: string): number | undefined => {
  const val = localStorage.getItem(key);
  if (!val) return undefined;

  return parseInt(val, 10);
};
